import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../layouts/Header";
import AutoStackPerformanceChart from "../../components/AutoStackPerformanceChart";
import AutoStackTransactionHistory from "../../components/AutoStackTransactionHistory";
import {
  useSingleAutoStackStats,
  useUserSingleAutoStack,
} from "../../hooks/query/queries";
import { useAssetsStore } from "../../store/use-assets-store";
import SingleAutoStackSkeleton from "../../components/skeletons/SingleAutoStackSkeleton";

export default function SingleAutoStack() {
  const { stackId } = useParams<{ stackId: string }>();
  const {
    data: autoStackStats,
    isLoading: isLoadingAutoStackStats,
    isFetching: isFetchingAutoStackStats,
  } = useSingleAutoStackStats(stackId);
  const {
    data: userSingleAutoStack,
    isLoading: isLoadingUserSingleAutoStack,
    isFetching: isFetchingUserSingleAutoStack,
  } = useUserSingleAutoStack(stackId);

  const { fetchAssets } = useAssetsStore();

  useEffect(() => {
    fetchAssets();
  }, [fetchAssets]);

  if (
    isLoadingUserSingleAutoStack ||
    isLoadingAutoStackStats ||
    isFetchingAutoStackStats ||
    isFetchingUserSingleAutoStack
  ) {
    return (
      <>
        <Header />
        <SingleAutoStackSkeleton />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="px-6 md:px-14 py-6 bg-bg-light-gray rounded-t-2xl space-y-8 h-[calc(100vh-100px)]">
        <div className="flex flex-wrap md:flex-nowrap items-stretch gap-6 w-full">
          <div className="w-full md:w-1/2">
            <AutoStackPerformanceChart
              autoStackStats={autoStackStats}
              isLoading={isLoadingAutoStackStats || isFetchingAutoStackStats}
              singleAutoStack={userSingleAutoStack}
              chartHeight="h-80"
            />
          </div>
          <div className="w-full md:w-1/2 flex">
            {stackId && <AutoStackTransactionHistory stackId={stackId} />}
          </div>
        </div>
      </div>
    </>
  );
}
